var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11202_9904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2812 16.0833C20.5 16.2396 20.5625 16.5521 20.375 16.7708L20.0625 17.1458C19.875 17.3646 19.5625 17.4271 19.375 17.2396L0.6875 2.61458C0.46875 2.45833 0.40625 2.14583 0.59375 1.92708L0.90625 1.52083C1.09375 1.33333 1.40625 1.27083 1.625 1.45833L20.2812 16.0833ZM5.59375 12.8333H11.3125L13.2188 14.3333H4.5C3.875 14.3333 3.5 13.8646 3.5 13.3333C3.46875 13.1146 3.5625 12.8646 3.75 12.6771C4.3125 12.0521 5.375 11.1146 5.46875 8.27083L6.875 9.39583C6.6875 11.1146 6.125 12.1458 5.59375 12.8333ZM10.5 4.33333C9.75 4.33333 9.09375 4.58333 8.53125 4.95833L7.3125 4.02083C7.9375 3.52083 8.6875 3.17708 9.5 2.98958V2.33333C9.5 1.80208 9.9375 1.33333 10.5 1.33333C11.0312 1.33333 11.4688 1.80208 11.4688 2.33333V2.98958C13.7812 3.48958 15.4688 5.42708 15.4688 7.83333C15.4688 9.14583 15.6562 10.0521 15.9375 10.7396L14.0625 9.30208C14.0312 8.86458 13.9688 8.39583 13.9688 7.86458C13.9688 7.86458 14 7.86458 14 7.83333C14 5.92708 12.4062 4.33333 10.5 4.33333ZM10.5 17.3333C9.375 17.3333 8.5 16.4583 8.5 15.3333H12.4688C12.4688 16.4583 11.5938 17.3333 10.5 17.3333Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11202_9904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.c9f859445c6ae43a1a5a6c199c28a5af.svg";
export { ForwardRef as ReactComponent };